<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>日程</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content_top">
        <el-form :inline="true" :model="search_form" class="demo-form-inline">
          <el-form-item label="关键字">
            <el-input size="small" v-model="search_form.kw" placeholder="支持内容模糊搜索"></el-input>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              size="small"
              v-model="search_form.date""
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="query">查询</el-button>
          </el-form-item>

          <el-form-item class="add">
            <router-link :to="{path:'/daily/schedule/multi'}">
              <el-button type="primary" size="small" icon="el-icon-circle-plus-outline">当日日程</el-button>
            </router-link>

            <router-link :to="{path:'/daily/schedule/save'}">
              <el-button type="primary" size="small" icon="el-icon-circle-plus-outline">添加</el-button>
            </router-link>
          </el-form-item>
        </el-form>
      </div>
      <div class="content">
        <el-table border :data="schedule_list">
          <el-table-column prop="date" label="日期" align="center"></el-table-column>
          <el-table-column prop="content" label="内容" align="center"></el-table-column>
          <el-table-column prop="start_time" label="开始时间" align="center"></el-table-column>
          <el-table-column prop="end_time" label="结束时间" align="center"></el-table-column>
          <el-table-column label="是否完成" align="center">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              <el-tag :type="scope.row && scope.row.status == 1 ? 'success' : 'danger'">
                {{ scope.row && scope.row.status_str}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              <router-link :to="{ path : '/daily/schedule/save', query:{ id: scope.row.id}}">
                <el-button type="text" icon="el-icon-edit">修改</el-button>
              </router-link>

              <el-button
                v-if="scope.row.is_del == 0"
                class="success"
                type="text"
                @click="deleteSchedule(scope.row.id)"
                icon="el-icon-setting"
              >删除</el-button>

              <el-button v-if="scope.row && scope.row.status == -1" class="primary" type="text" @click="allowSchedule(scope.row)" icon="el-icon-setting">
                完成
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[pageSize]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 15,
      schedule_list: [],
      search_form: {
        kw: '',
        date: '',
      },
      condition: {
        kw: '',
        date: '',
      },
    };
  },
  methods: {
    currentChange(page) {
      this.page = page;
      this.getSchedules(this.condition);
    },
    deleteSchedule(id) {
      let _id = id;
      this.$confirm("是否删除该条日程吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          url: "/daily/schedule/delete",
          data:{
            id: _id,
          },
          type:"POST",
        }).then(res => {
          loading.close()
          this.$util.msg(res.msg, "success");
          setTimeout(() => {
            this.getSchedules();
          }, 1200);
        });
      })
      .catch(() => {});
    },
    allowSchedule(remind) {
      var loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'hsla(0,0%,100%,.9)',
      });

      this.$ajax({
        url: "/daily/schedule/ops",
        data:{
          id: remind.id,
          act: 'mark',
        },
        type:"POST",
      }).then(res => {
        loading.close()
        this.$util.msg(res.msg, "success");
        setTimeout(() => {
          this.getSchedules(this.condition);
        }, 1200);
      });
    },
    getSchedules(condition) {
      this.$ajax({
        url: "/daily/schedule/index",
        data:{
          page: this.page,
          limit: this.pageSize,
          kw: condition.kw || '',
          date: condition.date || '',
        }
      }).then(data => {
        this.condition = condition
        this.schedule_list = data.data.data;
        this.total = data.data.total;
      });
    },
    query() {
      this.page = 1;
      this.getSchedules(this.search_form);
    },
  },
  mounted() {
    this.getSchedules(this.condition);
  },
};
</script>
<style>
  .add{
    float: right;
  }
</style>